import { render, staticRenderFns } from "./commonCar.vue?vue&type=template&id=5d3bd40b&scoped=true&"
import script from "./commonCar.vue?vue&type=script&lang=js&"
export * from "./commonCar.vue?vue&type=script&lang=js&"
import style0 from "./commonCar.vue?vue&type=style&index=0&id=5d3bd40b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3bd40b",
  null
  
)

export default component.exports